import { G } from '@mobily/ts-belt';

import { PostB2bWithdrawalRequestEndpoint } from '@Common/types/bo/b2b/withdrawals';

import type { From } from '@sh4res/bo-common/resources/b2b/withdrawals/steps/GeneralInfoStep';

// Payouts for deceased savers must never go to a saved account of the saver or the company.
export const isThirdPartyOnlyWithdrawal = ({
  isDeceased,
  earlyReason,
}: {
  isDeceased?: boolean | null;
  earlyReason?: string | null;
}) => isDeceased === true || earlyReason === 'savers_death';

export type ParsedAllocation = {
  instrument_id?: number;
  saving_plan_id: string;
  amount: number;
  type: 'locked' | 'withdrawable';
};

export function parseAllocations(
  allocationsData: Record<`${number}-${string}`, number | null>,
  type: 'locked' | 'withdrawable',
): ParsedAllocation[] {
  const allocationsArray: ParsedAllocation[] = [];

  Object.entries(allocationsData).forEach(([planInstrumentId, amount]) => {
    if (G.isNullable(amount) || amount <= 0) {
      return;
    }

    if (planInstrumentId.startsWith('plan-')) {
      const planId = planInstrumentId.replace('plan-', '');
      allocationsArray.push({
        saving_plan_id: planId,
        amount,
        type,
      });
    } else {
      const [instrumentId, planId] = planInstrumentId.split('-');
      if (G.isNullable(instrumentId) || G.isNullable(planId)) {
        return;
      }

      allocationsArray.push({
        instrument_id: parseInt(instrumentId),
        saving_plan_id: planId,
        amount,
        type,
      });
    }
  });

  return allocationsArray;
}

export function createWithdrawalAllocations(
  allocationsData: Record<`${number}-${string}`, number>,
  from: From,
): PostB2bWithdrawalRequestEndpoint['Client']['RequestBody']['allocations'] {
  return parseAllocations(allocationsData, from === 'early' ? 'locked' : 'withdrawable');
}
